import {AppConfig} from "@/app/config/AppConfig";
import Util from "@/Master/Util";
import packageJson from "../../../../package.json";

const config: AppConfig = {
    productId: 210,
    releaseProductId: 70055,
    ia_host: "xtg-test.kingsna.com",

    productVersion: '_PWA_VERSION_',//动态生成的版本号

    privacy_url: "http://evolvegrouplimited.com/privacy.html",
    trems_url: "http://evolvegrouplimited.com/terms.html",
    sweepstakes_rules_url: "http://evolvegrouplimited.com/clover/sweepsrules.html",
    responsible_play_url: "http://evolvegrouplimited.com/clover/responsible.html",
    game_statement: "http://evolvegrouplimited.com/clover/gamestatement.html    ",
    mail: "contact@gogogoldwin.com",

    game_api_url: "https://test-hs-back.winjoy99.com",
    nat_host: "test-sdk.letswinjoy.com",

    h5_version_code: packageJson.version_core,
    h5_version_name: packageJson.version,
    h5_app_name: packageJson.name,

    h5_package_name: "ifitness.home.workout.body.exercise",
    h5_host_name: Util.isWindow ? encodeURIComponent(window.location.host) : '',

    h5_mode: 1,//0默认PWA模式 1直接进入游戏模式
    h5_res_host: "https://oss-gz-sc-zydown.oss-accelerate.aliyuncs.com/SlotGameCenterH5/",
    h5_res_ver: "webgl/version_1/",

    GTM_ID: "GTM-WS59ZGP2",

    sm_businessId: "h5_vxozpcpsms",
    sm_apiKey: "un8tx6z8hxm5wetsl8rvfy23t9vvrj4ah2b4",
};

export default config; // 确保有默认导出
